<form [formGroup]="pressureForm" (ngSubmit)="onSubmit()">

  <div class="p-5">
    <div class="flex justify-center items-baseline flex-wrap">
      <div class="flex m-2">
        <mat-form-field>      
          <mat-label>Gamma (ɣ) &nbsp; value</mat-label>      
          <input matInput formControlName="gammaVal" autocomplete="off">
          <mat-error *ngIf="pressureForm.invalid && pressureForm.touched">
            <span class="myerror">1.0 &lt; ɣ &le; 1.67</span>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="flex m-2">
        <mat-form-field>       
          <mat-label>Pressure ratio</mat-label>     
          <input matInput formControlName="pressureVal" autocomplete="off">
          <mat-error *ngIf="pressureForm.invalid && pressureForm.touched">
            Pressure ratio should be less than 1
          </mat-error>
        </mat-form-field>
      </div>  
    </div>

    <div class="sbmtArea flex justify-center items-baseline flex-wrap">
      <button mat-raised-button type="submit" [disabled]="pressureForm.invalid">Calculate</button>
    </div>

   
  </div>




    <!-- <div>
      
      <div>
        <mat-form-field>      
          <mat-label>Gamma (ɣ) &nbsp; value</mat-label>      
          <input matInput formControlName="gammaVal" autocomplete="off">
          <mat-error *ngIf="pressureForm.invalid && pressureForm.touched">
            <span class="myerror">1.0 &lt; ɣ &le; 1.67</span>
          </mat-error>
        </mat-form-field>
      </div>
  
      <div>
        <mat-form-field>       
          <mat-label>Pressure ratio</mat-label>     
          <input matInput formControlName="pressureVal" autocomplete="off">
          <mat-error *ngIf="pressureForm.invalid && pressureForm.touched">
            Pressure ratio should be less than 1
          </mat-error>
        </mat-form-field>
      </div>
  
    </div> -->
  
    <!-- <div class="sbmtArea">
      <button mat-raised-button type="submit" [disabled]="pressureForm.invalid">Calculate</button>
    </div>
   -->
  </form>
  
  <div class="flex justify-center items-baseline flex-wrap" *ngIf="pBool">
    <table>
      <tr>
        <td>
            Mach
        </td>
        <td> {{ isenMach()}} </td>
      </tr>
      <tr>
        <td> T / T<sub>t</sub></td>
        <td>
          {{ isenT_Tt() | number:'.1-5' }}
        </td>
      </tr>
      <tr>
        <td>
            <p>A / A<sup>*</sup></p>
        </td>
        <td>{{ isenA_As() | number:'.1-5'}}</td>
      </tr>
      <tr>
        <td>
            <!-- pA &frasl; p<sub>t</sub> A* -->
             <img src="assets/math/paptas2.svg" alt="">

        </td>
        <td>
          <span class="asana2">{{ isenpA_ptAstar()  | number:'.1-5'  }}</span>
        </td>
      </tr>
      <tr>
        <td>
            PM
        </td>
        <td>{{ isenpm() | number:'.1-5' }}</td>
      </tr>
      <tr>
        <td>
            <!-- Mach angle -->
            <img src="assets/math/mach_ang_b.svg" alt="">

        </td>
        <td>
          <span class="asana2">{{ isenmach_angle() | number:'.1-5' }}</span>
          
        </td>
      </tr>
      <tr>
        <td>
          <!-- CFopt -->
          <img src="assets/math/cfopt_b.svg" alt="">

        </td>
        <td>
          <span class="asana2">{{isen_cfopt() | number:'.1-5' }}</span></td>
      </tr>
      <tr>
        <td>rt/rt</td>
        <td>{{ isen_rhot() | number:'.1-5' }}</td>
      </tr>
    </table>
  </div>